import React, { useState } from "react";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRangePicker, createStaticRanges } from "react-date-range";
import "./Appointments.scss";
import moment from "moment";

export default function AppointmentDateRangePicker({
  closeDatePicker,
  fetchDates,
  class_name,
  datePickerType,
  isDashboard,
}) {
  const today = new Date();
  const lastWeek = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - 7
  );
  const lastWeekMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    today.getDate()
  );
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    dateDisplayFormat: "DD MMM YYYY",
    rangeColors: "#F969A4",
    color: "#F969A4",
    key: "selection",
  });

  const [focusedRange, setFocusedRange] = useState([0, 0]);

  const defaultStaticRanges = createStaticRanges([
    {
      label: "Today",
      range: () => ({
        startDate: today,
        endDate: today,
      }),
    },
    {
      label: "Last 7 Days",
      range: () => ({
        startDate: lastWeek,
        endDate: today,
      }),
    },
    {
      label: "Last 30 Days",
      range: () => ({
        startDate: lastWeekMonth,
        endDate: today,
      }),
    },
    {
      label: "Custom Date Range",
      range: () => ({
        endDate: new Date(),
        startDate: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate() - 1
        ),
      }),
    },
  ]);

  const handleSelect = (ranges) => {
    setSelectionRange(ranges);
  };

  const applyRange = () => {
    if (isDashboard) {
      localStorage.setItem("dashboardStartDate", selectionRange.startDate);
      localStorage.setItem("dashboardEndDate", selectionRange.endDate);
    } else {
      if (datePickerType === "date&time") {
        localStorage.setItem("appointmentStartDate", selectionRange.startDate);
        localStorage.setItem("appointmentEndDate", selectionRange.endDate);
      } else {
        localStorage.setItem(
          "appointmentCheckInStartDate",
          selectionRange.startDate
        );
        localStorage.setItem(
          "appointmentCheckInEndDate",
          selectionRange.endDate
        );
      }
    }

    fetchDates(selectionRange.startDate, selectionRange.endDate);
    closeDatePicker();
  };

  return (
    <div
      className={`appointment-date-range ${class_name}`}
      style={{ zIndex: "9999" }}
    >
      <DateRangePicker
        ranges={[selectionRange]}
        startDatePlaceholder="From"
        endDatePlaceholder="To"
        focusedRange={focusedRange}
        onRangeFocusChange={setFocusedRange}
        showSelectionPreview={true}
        editableDateInputs={true}
        showPreview={false}
        staticRanges={defaultStaticRanges}
        inputRanges={[]}
        onChange={(item) => handleSelect(item.selection)}
        maxDate={moment().add(1, "years").toDate()}
        moveRangeOnFirstSelection={false}
        retainEndDateOnFirstSelection={false}
        showDateDisplay={true}
      />
      <div className="d-flex col-sm-12 appointment-date-range-buttons-div p-2">
        <button
          className="offset-sm-8 appointment-date-range-cancel"
          onClick={closeDatePicker}
        >
          Cancel
        </button>
        <button
          className="ml-4 btn-primary appointment-date-range-apply"
          onClick={applyRange}
        >
          Apply
        </button>
      </div>
    </div>
  );
}
